import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Button from 'components/Button';
import GridBlock from 'components/GridBlock';
import Typography from "components/Typography";
import PropTypes from "prop-types";
import ENotices2Service from "services/ENotices2Service";
import {Box} from '@material-ui/core';
import Confirm from "../../../../../../../components/popup/confirm/Confirm";
import DelayedPublicationPopup from "./DelayedPublicationPopup";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";

function EnoticeSection(
    {
        id,
        classesRoot,
        editable,
        setWorking,
        isEuEnoticeStatusSuccess,
        isEnoticeStatusSubmitted,
        isEnoticeStatusPublished,
        isEnoticeAnnouncementStatusWaiting,
        preferredPublicationDate
    }) {
    const [openNoticeWithdrawPopup, setOpenNoticeWithdrawPopup] = useState(false);
    const [openDelayedPublicationPopup, setOpenDelayedPublicationPopup] = useState(false);

    const formattedPreferredPublicationDate = preferredPublicationDate && moment(preferredPublicationDate).isValid()
        ? moment(preferredPublicationDate).format(DateFormats.DATE_FORMAT)
        : null;
    const hasPreferredPublicationDate = Boolean(formattedPreferredPublicationDate);
    const handleEnoticeSendTed = (publicationDate) => {
        setOpenDelayedPublicationPopup(false);
        setWorking(true);
        ENotices2Service.publishNotice(id, publicationDate)
            .then(() => ENotices2Service.getNoticeStatusTed(id))
            .then(() => ENotices2Service.validateEnoticeSection(id))
            .finally(() => setWorking(false));
    };

    const handleEnoticeCheckStatus = () => {
        setWorking(true);
        ENotices2Service.getAnnouncementStatus(id)
            .finally(() => {
                setWorking(false);
            });
    };

    const handleWithdrawNotice = () => {
        setOpenNoticeWithdrawPopup(false);
        setWorking(true);
        ENotices2Service.withdrawNotice(id)
            .then(() => ENotices2Service.getNoticeStatusTed(id))
            .finally(() => setWorking(false));
    }

    return (
  <GridBlock
        className={classesRoot}
        direction="column"
        alignItems="center"
    >
        <GridBlock direction="column" alignItems="center" className={classesRoot}>
            {isEuEnoticeStatusSuccess && (
                <Typography>
                    <Box component='span' fontWeight='fontWeightBold'>
                        {Tr('enotice_prepared_action')}
                    </Box>
                </Typography>
            )}

            {isEnoticeAnnouncementStatusWaiting && (
                <Typography>
                    <Box component='span' fontWeight='fontWeightBold'>
                        {hasPreferredPublicationDate
                            ? Tr('enotice_waiting_eu_with_publication_date', {date: formattedPreferredPublicationDate})
                            : Tr('enotice_waiting_eu')}
                    </Box>
                </Typography>
            )}

            {isEnoticeStatusSubmitted && !isEnoticeAnnouncementStatusWaiting && (
                <Typography>
                    <Box component='span' fontWeight='fontWeightBold'>
                        {hasPreferredPublicationDate
                            ? Tr('enotice_prepared_eu_with_publication_date', {date: formattedPreferredPublicationDate})
                            : Tr('enotice_prepared_eu')}
                    </Box>
                </Typography>
            )}
            {
                isEnoticeStatusPublished &&
                <Typography>
                    <Box component='span' fontWeight='fontWeightBold'>
                        {Tr('enotice_published_eu')}
                    </Box>
                </Typography>
            }
            {
                isEnoticeStatusPublished &&
                <Typography>
                    <Box component='span' fontWeight='fontWeightBold'>
                        {Tr('enotice_withdraw_forbidden')}
                    </Box>
                </Typography>
            }
        </GridBlock>

        <GridBlock direction="column" alignItems="center" className={classesRoot}>
            {isEuEnoticeStatusSuccess && (
                <Button
                    disabled={!editable}
                    onClick={() => setOpenDelayedPublicationPopup(true)}
                >
                    {Tr('enotice_send_ted')}
                </Button>
            )}

            {isEnoticeStatusSubmitted && <Button
                onClick={handleEnoticeCheckStatus}
            >
                {Tr('enotice_check_notice_status')}
            </Button>}

            {isEnoticeStatusSubmitted && <Button
                disabled={!editable}
                onClick={() => setOpenNoticeWithdrawPopup(true)}>
                {Tr('enotice_withdraw_notice')}
            </Button>}
        </GridBlock>
      <Confirm
          open={openNoticeWithdrawPopup}
          onConfirm={handleWithdrawNotice}
          onCancel={() => setOpenNoticeWithdrawPopup(false)}
          confirmText="enotice_withdraw_notice_text"
          labelCancel="cancel"
          labelConfirm="confirm2"
      />
      <DelayedPublicationPopup
          open={openDelayedPublicationPopup}
          onConfirm={handleEnoticeSendTed}
          onCancel={() => setOpenDelayedPublicationPopup(false)}
      />
    </GridBlock>
    )
}

EnoticeSection.propTypes = {
    classes: PropTypes.any,
}

export default EnoticeSection;